<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :actions="actions"
            :title="title"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            :beforeSetupGrid="beforeSetupGrid"
            ref="grid"
        ></dx-grid>
        <v-dialog persistent v-model="updateTeacherDialog" max-width="1000">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Update Settings - {{ rowClicked.teacherH }}</v-card-title
                >

                <v-layout row>
                    <v-layout column xs6 class="pr-2" style="min-width: 40%">
                        <v-layout
                            row
                            class="mb-3 ma-0 pa-0"
                            v-if="!isContact()"
                        >
                            <v-btn
                                v-if="rowClicked.teacherNameRecording"
                                @click="rowClicked.teacherNameRecording = null"
                                flat
                                class="mr-2"
                                icon
                                color="red"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <audio
                                class="mr-3"
                                v-if="rowClicked.teacherNameRecording"
                                controls
                                :src="rowClicked.teacherNameRecording"
                            ></audio>
                            <v-btn
                                small
                                outline
                                class="mr-2"
                                :loading="uploading"
                                @click="pickFile()"
                            >
                                Upload
                                <v-icon right dark>mdi-cloud-upload</v-icon>
                            </v-btn>
                            <input
                                type="file"
                                style="display: none"
                                ref="files"
                                accept=".mp3"
                                @change="onFilePicked($event, false)"
                            />
                        </v-layout>
                        <v-text-field
                            class="mx-2"
                            v-model="rowClicked.alertPhone"
                            :label="
                                isContact()
                                    ? 'Phone Number'
                                    : 'Alert Phone Number'
                            "
                            ref="alertPhone"
                            :rules="[rules.phoneNumber, rules.required]"
                        ></v-text-field>
                        <v-text-field
                            v-if="!isContact()"
                            class="mx-2"
                            v-model="rowClicked.pinNumber"
                            label="Pin Number"
                            ref="pinNumber"
                            :rules="[rules.pinNumber]"
                        ></v-text-field>
                        <v-text-field
                            class="mx-2"
                            v-model="rowClicked.busNumber"
                            label="Bus Number"
                            v-if="rowClicked.type == 'BUS_DRIVER'"
                            ref="busNumber"
                        ></v-text-field>
                        <v-layout class="pa-0">
                            <v-text-field
                                class="mx-2 pt-1"
                                v-model="rowClicked.name"
                                label="Name"
                            ></v-text-field>
                            <v-btn
                                v-if="!isContact() && !isBusDriver()"
                                class="mb-0 pt-1"
                                :disabled="!rowClicked.name"
                                @click="playText(rowClicked.name)"
                                flat
                                icon
                                color="info"
                            >
                                <v-icon>mdi-play-circle</v-icon>
                            </v-btn>
                        </v-layout>
                        <v-layout class="pa-0">
                            <v-text-field
                                class="mx-2 pt-1"
                                v-model="rowClicked.nameH"
                                label="Hebrew Name"
                            ></v-text-field>
                        </v-layout>
                        <v-select
                            class="mx-2"
                            v-model="rowClicked.paymentType"
                            label="Payment Type"
                            ref="paymentType"
                            :items="['USBank', 'Check']"
                        ></v-select>
                        <!-- <v-select
                            v-if="!isContact() && !isBusDriver()"
                            class="mx-2"
                            v-model="rowClicked.connectionMode"
                            label="Connection Mode"
                            ref="connectionMode"
                            :items="['LIVE', 'MESSAGE']"
                        ></v-select> -->
                        <v-select
                            v-if="isContact() && isBusDriver()"
                            class="mx-2"
                            v-model="rowClicked.branch"
                            label="Branch"
                            ref="branch"
                            multiple
                            :items="branchList"
                        ></v-select>
                        <v-menu
                            v-if="!isContact()"
                            ref="alertTime"
                            v-model="timePickerMenu"
                            :close-on-content-click="false"
                            :return-value.sync="rowClicked.alertTime"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="rowClicked.alertTime"
                                    label="Alert Time"
                                    class="mx-2"
                                    readonly
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-time-picker
                                v-model="rowClicked.alertTime"
                                @input="saveAlertTime($event)"
                            ></v-time-picker>
                        </v-menu>
                        <v-switch
                            v-if="!isContact() && !isBusDriver()"
                            color="success"
                            class="mt-0"
                            v-model="rowClicked.allowBroadcast"
                            label="Allow Broadcast"
                            hide-details
                        ></v-switch>
                        <v-switch
                            v-if="!isContact() && !isBusDriver()"
                            color="success"
                            class="mt-3"
                            hide-details
                            v-model="rowClicked.allowChargeCC"
                            label="Allow Charge Credit Card (Tip)"
                        ></v-switch>
                        <v-switch
                            v-if="showAllowMessageSetting()"
                            color="success"
                            class="mt-3"
                            hide-details
                            v-model="rowClicked.allowMessage"
                            label="Allow Message"
                        ></v-switch>
                        <v-switch
                            color="success"
                            class="mt-3"
                            hide-details
                            v-model="rowClicked.doNotAlert"
                            label="Do Not Alert"
                        ></v-switch>

                        <v-switch
                            v-if="!isContact() && !isBusDriver()"
                            color="success"
                            class="mt-3"
                            hide-details
                            v-model="rowClicked.disabled"
                            label="Disabled"
                        ></v-switch>
                    </v-layout>
                    <v-divider vertical></v-divider>
                    <v-layout column xs6 class="pl-3" style="min-width: 56%">
                        <div style="overflow-y: auto; height: 600px;">
                            <v-layout row style="max-height: 30px;">
                                <div class="title pt-1">Positions</div>
                                <v-btn
                                    style="height: 28px;"
                                    class="my-0 ml-2"
                                    small
                                    @click="addPosition"
                                    color="success"
                                    >Add</v-btn
                                >
                            </v-layout>
                            <div
                                class="mt-3 pt-2"
                                v-for="(position,
                                index) in rowClicked.positions"
                            >
                                <v-layout row align-center>
                                    <v-layout column>
                                        <v-layout row class="mb-2">
                                            <v-checkbox
                                                color="success"
                                                v-model="position.isInactive"
                                                label="Inactive"
                                                class="mt-0 mr-3"
                                                style="max-width: 115px"
                                            >
                                            </v-checkbox>
                                            <v-select
                                                class="pr-1 pt-0 mt-0"
                                                label="Position"
                                                v-model="
                                                    position.positionDescription
                                                "
                                                :items="
                                                    positionTypes.map(
                                                        (p) =>
                                                            p.positionDescription,
                                                    )
                                                "
                                                @change="
                                                    positionChanged(position)
                                                "
                                                ref="positionType"
                                                style="max-width: 200px"
                                                :rules="[rules.required]"
                                            >
                                            </v-select>

                                            <v-text-field
                                                class="pr-1 pt-0 mt-0"
                                                v-if="showBusNumber(position)"
                                                label="Bus Number"
                                                v-model="position.busNum"
                                                ref="busNum"
                                                :rules="[rules.required]"
                                            ></v-text-field>
                                            <v-text-field
                                                class="pr-1 pt-0 mt-0"
                                                label="Reg ID"
                                                v-model="position.regID"
                                                disabled
                                                ref="regID"
                                            ></v-text-field>
                                        </v-layout>
                                        <v-layout row>
                                            <v-select
                                                class="pr-2 pt-0 mt-0"
                                                label="Branch"
                                                v-model="position.branch"
                                                :items="branchList"
                                                ref="branch"
                                                :rules="[rules.required]"
                                            ></v-select>
                                            <v-select
                                                class="pr-1 pt-0 mt-0"
                                                label="Grade"
                                                v-model="position.class"
                                                :items="gradeList"
                                                ref="grade"
                                            ></v-select>
                                            <v-text-field
                                                class="pr-1 pt-0 mt-0"
                                                label="Section"
                                                v-model="position.section"
                                                ref="section"
                                            ></v-text-field>
                                        </v-layout>
                                        <v-layout row>
                                            <v-text-field
                                                class="pr-1 pt-0 mt-0"
                                                label="Note"
                                                v-model="position.notes"
                                                ref="note"
                                            ></v-text-field>
                                        </v-layout>
                                        <v-layout row>
                                            <v-text-field
                                                class="pr-1 pt-0 mt-0"
                                                label="Bus Route"
                                                v-model="position.busRoute"
                                                ref="busRoute"
                                            ></v-text-field>
                                        </v-layout>
                                    </v-layout>
                                    <v-btn
                                        class="pt-0 mt-0"
                                        @click="addPosition"
                                        flat
                                        icon
                                        color="success"
                                    >
                                        <v-icon>mdi-plus-circle</v-icon>
                                    </v-btn>
                                    <v-btn
                                        class="pt-0 mt-0"
                                        @click="removePosition(index)"
                                        flat
                                        icon
                                        color="#f55a4e"
                                    >
                                        <v-icon
                                            >mdi-minus-circle-outline</v-icon
                                        >
                                    </v-btn>
                                </v-layout>
                                <v-divider
                                    class="mt-3"
                                    v-if="
                                        index + 1 < rowClicked.positions.length
                                    "
                                ></v-divider>
                            </div>
                        </div>
                    </v-layout>
                </v-layout>
                <v-card-actions class="mx-0 px-2 pb-2 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="updateTeacherDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="warning"
                        dark
                        v-if="isContact() || isBusDriver()"
                        :disabled="deletingTeacher"
                        @click="deleteTeacherConfirmationDialog = true"
                        >Delete</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="save()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="addNewTeacherDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >New Contact</v-card-title
                >
                <v-layout
                    row
                    class="mb-3 ma-0 pa-0"
                    v-if="newTeacher.type == 'BUS_DRIVER'"
                >
                    <v-btn
                        v-if="newTeacher.teacherNameRecording"
                        @click="newTeacher.teacherNameRecording = null"
                        flat
                        class="mr-2"
                        icon
                        color="red"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <audio
                        class="mr-3"
                        v-if="newTeacher.teacherNameRecording"
                        controls
                        :src="newTeacher.teacherNameRecording"
                    ></audio>
                    <v-btn
                        small
                        outline
                        class="mr-2"
                        :loading="uploading"
                        @click="pickFile(true)"
                    >
                        Upload
                        <v-icon right dark>mdi-cloud-upload</v-icon>
                    </v-btn>
                    <input
                        type="file"
                        style="display: none"
                        ref="newTeacherFiles"
                        accept=".mp3"
                        @change="onFilePicked($event, true)"
                    />
                </v-layout>
                <v-text-field
                    class="mx-2"
                    v-model="newTeacher.alertPhone"
                    :label="
                        newTeacher.type == 'CONTACTS'
                            ? 'Phone Number'
                            : 'Alert Phone Number'
                    "
                    ref="newAlertPhone"
                    :rules="[rules.phoneNumber, rules.required]"
                ></v-text-field>
                <v-text-field
                    class="mx-2"
                    v-if="newTeacher.type == 'BUS_DRIVER'"
                    v-model="newTeacher.busNumber"
                    label="Bus Number"
                    ref="busNumber"
                    :rules="[rules.required]"
                ></v-text-field>
                <v-select
                    class="mx-2"
                    :disabled="newTeacher.type == 'BUS_DRIVER'"
                    v-model="newTeacher.branch"
                    label="Branch"
                    multiple
                    :items="branchList"
                ></v-select>
                <v-layout class="pa-0">
                    <v-text-field
                        class="mx-2 pt-1"
                        v-model="newTeacher.name"
                        label="Name"
                        ref="newName"
                        :rules="[rules.required]"
                    ></v-text-field>
                    <!-- <v-btn
                        class="mb-0 pt-1"
                        :disabled="!newTeacher.name"
                        @click="playText(newTeacher.name)"
                        flat
                        icon
                        color="info"
                    >
                        <v-icon>mdi-play-circle</v-icon>
                    </v-btn> -->
                </v-layout>
                <v-layout class="pa-0">
                    <v-text-field
                        class="mx-2 pt-1"
                        v-model="newTeacher.nameH"
                        label="Hebrew Name"
                        ref="newNameH"
                        :rules="[rules.required]"
                    ></v-text-field>
                </v-layout>
                <v-card-actions class="mx-0 px-2 pb-2 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="addNewTeacherDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveNewTeacher()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="deleteTeacherConfirmationDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline text-danger"
                    >Are You Sure?</v-card-title
                >
                <v-card-text class="pt-0"
                    >This will delete:
                    <div class="font-weight-medium">
                        {{
                            rowClicked.nameH
                                ? rowClicked.nameH
                                : rowClicked.name
                        }}
                    </div></v-card-text
                >
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="deleteTeacherConfirmationDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        :loading="deletingTeacher"
                        @click="deleteTeacher"
                        >Delete</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Import Employee Dialog -->
        <v-dialog
            persistent
            v-model="importEmployeeDialog"
            :max-width="selectedImportEmployee ? 400 : 1400"
        >
            <v-card class="pa-3">
                <v-card-title class="headline py-0 pl-0">
                    Import Employee
                </v-card-title>

                <!-- Data Grid (only shown when no employee selected) -->
                <div v-if="!selectedImportEmployee" class="employee-list">
                    <data-grid
                        class="employee-search"
                        url="EmployeeList"
                        :columns="employeeImportColumns"
                        title="Employees"
                        v-bind:hideActions="true"
                        v-bind:hideHeader="false"
                        navigationPath="onEmployeeImportRowClicked"
                        navigationField="onEmployeeImportRowClicked"
                        :onRowClicked="onEmployeeImportRowClicked"
                        :perPage="5"
                    ></data-grid>
                </div>

                <!-- Selected Employee Preview (shown after selection) -->
                <div v-else class="mt-3">
                    <v-layout row>
                        <v-layout column>
                            <v-layout row>
                                <div class="font-weight-medium width-150">
                                    Employee ID:
                                </div>
                                <div>
                                    {{ selectedImportEmployee.employeeID }}
                                </div>
                            </v-layout>
                            <v-layout row>
                                <div class="font-weight-medium width-150">
                                    Name:
                                </div>
                                <div>
                                    {{
                                        selectedImportEmployee.firstName +
                                            " " +
                                            selectedImportEmployee.lastName
                                    }}
                                </div>
                            </v-layout>
                            <v-layout row>
                                <div class="font-weight-medium width-150">
                                    Hebrew Name:
                                </div>
                                <div>
                                    {{ selectedImportEmployee.hebrewName }}
                                </div>
                            </v-layout>
                            <v-layout row>
                                <div class="font-weight-medium width-150">
                                    Phone:
                                </div>
                                <div>{{ selectedImportEmployee.phone1 }}</div>
                            </v-layout>
                            <v-layout row>
                                <div class="font-weight-medium width-150">
                                    Branch:
                                </div>
                                <div>{{ selectedImportEmployee.branch }}</div>
                            </v-layout>
                            <v-layout row>
                                <div class="font-weight-medium width-150">
                                    Department:
                                </div>
                                <div>
                                    {{ selectedImportEmployee.department }}
                                </div>
                            </v-layout>
                            <v-layout row>
                                <div class="font-weight-medium width-150">
                                    Position:
                                </div>
                                <div>{{ selectedImportEmployee.position }}</div>
                            </v-layout>
                            <v-btn
                                style="max-width: 150px;"
                                small
                                outline
                                class="mb-3"
                                color="success"
                                @click="clearSelectionAndShowGrid"
                            >
                                <v-icon small left>mdi-swap-horizontal</v-icon>
                                Change Employee
                            </v-btn>
                        </v-layout>
                    </v-layout>
                </div>

                <!-- Action Buttons -->
                <v-card-actions class="mx-0 px-2 pb-2 mt-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="importEmployeeDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        :disabled="!selectedImportEmployee"
                        :loading="importingEmployee"
                        @click="importEmployee"
                    >
                        Import
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import moment from "moment";
import AWS from "aws-sdk";

export default {
    data: () => ({
        title: "Kesher Employess",

        actions: [],

        updateTeacherDialog: false,
        timePickerMenu: false,

        rowClicked: {
            teacherCode: "",
            teacherNameRecording: "",
            alertPhone: "",
            connectionMode: "",
            pinNumber: "",
            alertTime: "",
            type: "",
            allowBroadcast: "",
            allowChargeCC: "",
            allowMessage: "",
            doNotAlert: "",
            disabled: "",
            busNumber: "",
            paymentType: "",
            positions: [],
        },

        newTeacher: {
            teacherCode: "",
            teacherNameRecording: "",
            alertPhone: "",
            connectionMode: "",
            branch: [],
            pinNumber: "",
            alertTime: "",
            allowBroadcast: "",
            allowChargeCC: "",
            allowMessage: "",
            disabled: "",
            busNumber: "",
            name: "",
            nameH: "",
            type: "CONTACTS",
            paymentType: "USBank",
            doNotAlert: false,
            positions: [],
        },

        processing: false,
        uploading: false,
        deleteTeacherConfirmationDialog: false,
        deletingTeacher: false,
        files: [],
        types: [],
        url: "",
        regID: "",
        awsPolly: "",
        branchList: [],
        gradeList: [],
        positionTypes: [],

        addNewTeacherDialog: false,

        importEmployeeDialog: false,
        importingEmployee: false,
        selectedImportEmployee: null,

        rules: {
            required: (value) => !!value || "Required.",
            pinNumber: (v) => {
                return (
                    !v ||
                    ([5].includes(v.replace(/-/g, "").length) &&
                        /^\d+$/.test(v.replace(/-/g, ""))) ||
                    "Invalid Pin Number, Must be 5 digits"
                );
            },
            phoneNumber: (v) => {
                return (
                    !v ||
                    ([10, 11].includes(v.replace(/-/g, "").length) &&
                        /^\d+$/.test(v.replace(/-/g, ""))) ||
                    "Invalid Phone Number"
                );
            },
        },

        columns: [
            {
                label: "Employee ID",
                field: "employeeID",
                visible: true,
                link: "TeacherView",
                template: "link-cell-template",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher Code",
                field: "teacherCode",
                visible: true,
                //link: "TeacherView",
                //template: "link-cell-template",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Hebrew Name",
                field: "teacherH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name",
                field: "teacher",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Recording",
                template: "link-audio-cell-template",
                field: "teacherNameRecording",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Class",
                field: "class",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Section",
                field: "section",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Branch",
                field: "branch",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Building",
                field: "building",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Alert Phone",
                field: "alertPhone",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Pin Number",
                field: "pinNumber",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Alert Time",
                field: "alertTime",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Type",
                field: "type",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Payment Type",
                field: "paymentType",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "US Bank Card",
                field: "usBankCard",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Bus Number",
                field: "busNumber",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            // {
            //     label: "Connection Mode",
            //     field: "connectionMode",
            //     visible: true,
            //     filterValues: [],
            //     filterValue: null,
            //     selectedFilterOperation: null,
            // },
            {
                label: "Allow Message",
                field: "allowMessage",
                visible: true,
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Do Not Alert",
                field: "doNotAlert",
                visible: true,
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Allow Broadcast",
                field: "allowBroadcast",
                visible: true,
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Disabled",
                field: "disabled",
                visible: true,
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Is Inactive",
                field: "isInactive",
                visible: true,
                type: "boolean",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Bus Route",
                field: "busRoute",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Notes",
                field: "notes",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            // {
            //     label: "Allow Charge CC",
            //     field: "allowChargeCC",
            //     visible: true,
            //     type: "boolean",
            //     filterValues: [],
            //     filterValue: null,
            //     selectedFilterOperation: null,
            // },
            {
                label: "Last Call At",
                field: "lastCallAt",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Tip Balance",
                field: "tipBalance",
                type: "number",
                format: {
                    type: "currency",
                    precision: 2,
                },
                precision: 3,
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],

        employeeImportColumns: [
            {
                sortable: true,
                label: "Employee ID",
                field: "employeeID",
                type: "number",
                hidden: false,
                width: "100px",
                filterOptions: {
                    enabled: true,
                    placeholder: "Search ID..",
                },
            },
            {
                sortable: true,
                label: "First Name",
                field: "firstName",
                width: "150px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search First Name..",
                },
            },
            {
                sortable: true,
                label: "Last Name",
                field: "lastName",
                width: "120px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Last Name..",
                },
            },
            {
                sortable: true,
                label: "Hebrew Name",
                field: "hebrewName",
                width: "150px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Hebrew Name..",
                },
            },
            {
                sortable: true,
                label: "Phone",
                field: "phone1",
                width: "130px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Phone..",
                },
            },
            {
                sortable: true,
                label: "Branch",
                field: "branch",
                width: "150px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Phone..",
                },
            },
            {
                sortable: true,
                label: "Department",
                field: "department",
                width: "160px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Phone..",
                },
            },
            {
                sortable: true,
                label: "Position",
                field: "position",
                width: "130px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Phone..",
                },
            },
        ],
    }),
    async mounted() {
        const settings = await this.getAwsSettings();

        this.awsPolly = new AWS.Polly({
            accessKeyId: settings.accessKey,
            secretAccessKey: settings.secretKey,
            region: "us-east-1",
        });
    },
    beforeDestroy() {},
    async created() {
        //this.updateTeacherSettings();

        this.loadBranches();
        this.loadGradesList();
        this.loadPositionTypes();
    },
    methods: {
        async getAwsSettings() {
            const response = await this.$http.get(
                "api/adminPortal/GetAwsPollyCredentials",
            );

            return response;
        },
        async beforeSetupGrid() {
            if (this.getBranch()) {
                this.userBranch = this.getBranch();

                this.addRestrictions();
            }

            await this.loadRegID();

            const terms = await this.getTerms();

            this.actions.push({
                text: "Import Employee",
                action: this.openImportEmployeeDialog,
            });

            this.actions.push({
                text: "Select Term",
                type: "select",
                values: terms,
                value: this.regID,
                onSelected: this.onTermSelected,
            });

            this.url =
                "kesherEmployees?branch=" +
                (this.userBranch ? this.userBranch : "") +
                "&grade=&regID=" +
                this.regID;
        },
        async loadBranches() {
            const branches = await this.$http.get(
                "api/students/getBranchList?grades=",
            );

            this.branchList = branches.sort();
            this.branchList.push("BUS");
        },
        async loadGradesList() {
            const grades = await this.$http.get(
                "api/students/getGradeList?branch=",
            );

            this.gradeList = grades.sort();
        },
        async loadPositionTypes() {
            this.positionTypes = await this.$http.get(
                "api/kesherEmployees/getPositionTypes",
            );
        },
        positionChanged(position) {
            const positionType = this.positionTypes.find(
                (p) => p.positionDescription == position.positionDescription,
            );

            if (!positionType) return;

            if (
                ["BUS_DRIVER", "BusRebbe", "BusTeacher"].includes(
                    positionType.positionCode,
                )
            ) {
                position.branch = "BUS";

                this.$forceUpdate();
            }
        },
        addRestrictions() {
            this.columns = this.columns.filter(
                (c) =>
                    ![
                        "pinNumber",
                        "alertTime",
                        "connectionMode",
                        "allowBroadcast",
                        "doNotAlert",
                        "disabled",
                        "allowChargeCC",
                        "allowMessage",
                        "lastCallAt",
                        "tipBalance",
                        "paymentType",
                    ].includes(c.field),
            );

            this.columns.find((t) => t.field == "teacherCode").link = null;
            this.columns.find((t) => t.field == "teacherCode").template = null;
        },
        async loadRegID() {
            this.regID = await this.$http.get("api/allStudents/getRegID");
        },
        async getTerms() {
            return await this.$http.get("api/allStudents/getRegTerms");
        },
        onTermSelected(value) {
            this.regID = value;

            this.url =
                "kesherEmployees?branch=" +
                (this.userBranch ? this.userBranch : "") +
                "&grade=&regID=" +
                this.regID;

            this.$refs.grid.reloadDataSource(this.url);
        },
        getBranch() {
            return this.$store.state.authentication.branch &&
                !this.$store.state.authentication.branch.includes("null")
                ? this.$store.state.authentication.branch
                : "";
        },
        isBusDriverBranch() {
            return this.userBranch.includes("BUS");
        },
        isContact() {
            return this.rowClicked.type == "CONTACTS";
        },
        isBusDriver() {
            return this.rowClicked.type == "BUS_DRIVER";
        },
        openImportEmployeeDialog() {
            this.importEmployeeDialog = true;
            this.selectedImportEmployee = null;
        },
        clearSelectionAndShowGrid() {
            this.selectedImportEmployee = null;
        },
        onEmployeeImportRowClicked(employee) {
            this.selectedImportEmployee = employee;
        },
        async importEmployee() {
            if (!this.selectedImportEmployee) return;

            this.importingEmployee = true;

            try {
                const kesherEmployee = await this.$http.post(
                    "api/EmployeeList/SaveKesherEmployee",
                    this.selectedImportEmployee,
                );

                this.$notify({
                    text: "Employee imported successfully",
                    group: "notification",
                    type: "success",
                });

                this.importEmployeeDialog = false;

                if (kesherEmployee) {
                    this.onRowClicked(kesherEmployee);
                }

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.$notify({
                    text: "Failed to import employee",
                    group: "notification",
                    type: "error",
                });
            } finally {
                this.importingEmployee = false;
                this.selectedImportEmployee = null;
            }
        },
        async saveNewTeacher() {
            if (
                !this.$refs.newName.validate(true) ||
                !this.$refs.newNameH.validate(true) ||
                !this.$refs.newAlertPhone.validate(true)
            )
                return;

            if (!this.newTeacher.branch.length) {
                return this.$notify({
                    text: "Please select branch",
                    group: "notification",
                    type: "error",
                });
            }

            try {
                this.processing = true;

                await this.$http.post("api/teachers/saveNewTeacher", {
                    phoneNumber: this.newTeacher.alertPhone
                        ? this.newTeacher.alertPhone.length == 11
                            ? this.newTeacher.alertPhone
                            : "1" + this.newTeacher.alertPhone
                        : "",
                    name: this.newTeacher.name,
                    nameH: this.newTeacher.nameH,
                    branch: this.newTeacher.branch.join(","),
                    busNumber: this.newTeacher.busNumber,
                    nameRecording: this.newTeacher.teacherNameRecording,
                    type: this.newTeacher.type,
                });

                this.processing = false;
                this.addNewTeacherDialog = false;

                this.newTeacher.teacherCode = "";
                this.newTeacher.teacherNameRecording = "";
                this.newTeacher.alertPhone = "";
                this.newTeacher.connectionMode = "";
                this.newTeacher.branch = [];
                this.newTeacher.pinNumber = "";
                this.newTeacher.alertTime = "";
                this.newTeacher.doNotAlert = "";
                this.newTeacher.allowBroadcast = "";
                this.newTeacher.allowChargeCC = "";
                this.newTeacher.allowMessage = "";
                this.newTeacher.disabled = "";
                this.newTeacher.paymentType = "USBank";
                this.newTeacher.busNumber = "";
                this.newTeacher.name = "";
                this.newTeacher.nameH = "";
                this.newTeacher.type = "CONTACTS";

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async onRowClicked(row) {
            if (
                this.userBranch &&
                !this.userBranch.includes("BUS") &&
                row.type != "CONTACTS"
            ) {
                return this.$notify({
                    text: "Can't edit teacher",
                    group: "notification",
                    type: "error",
                });
            }

            this.rowClicked = JSON.parse(JSON.stringify(row));
            this.rowClicked.alertTime = this.rowClicked.alertTime
                ? moment(this.rowClicked.alertTime, "hh:mm A").format("HH:mm")
                : "";

            this.rowClicked.name = row.teacher;
            this.rowClicked.nameH = row.teacherH;
            this.rowClicked.teacherNameRecording = row.teacherNameRecording;

            const positions = await this.$http.get(
                "api/kesherEmployees/getPositions?employeeID=" +
                    this.rowClicked.employeeID +
                    "&regID=" +
                    this.regID,
            );

            this.rowClicked.positions = positions.map((position) => {
                if (position.positionTypeID) {
                    const positionType = this.positionTypes.find(
                        (pt) => pt.positionTypeID == position.positionTypeID,
                    );

                    position.positionDescription =
                        positionType.positionDescription;
                    position.positionCode = positionType.positionCode;
                }

                return position;
            });

            this.updateTeacherDialog = true;
        },
        showAllowMessageSetting() {
            if (!this.rowClicked.positions) return;

            const positionList = ["TEACHER", "Y_TEACHER", "E_TEACHER", "NIGHT"];

            return (
                positionList.includes(this.rowClicked.positionCode) ||
                this.rowClicked.positions.some((p) =>
                    positionList.includes(p.positionCode),
                )
            );
        },
        addBusDriver() {
            this.newTeacher.type = "BUS_DRIVER";
            this.newTeacher.branch = ["BUS"];

            this.addNewTeacherDialog = true;
        },
        addContacts() {
            this.newTeacher.type = "CONTACTS";

            this.addNewTeacherDialog = true;
        },
        async updateTeacherSettings() {
            await this.$http.post("api/teachers/updateTeacherSettings");

            return this.$notify({
                text: "Teacher Settings Updated",
                group: "notification",
                type: "success",
            });
        },
        addPosition() {
            this.rowClicked.positions.push({
                employeeID: this.rowClicked.employeeID,
                positionTypeID: "",
                positionDescription: "",
                branch: "",
                regID: this.regID,
                class: "",
                section: "",
                busNum: "",
                isInactive: false,
                busRoute: "",
                notes: "",
            });

            this.$forceUpdate();
        },
        removePosition(index) {
            this.rowClicked.positions.splice(index, 1);

            this.$forceUpdate();
        },
        showBusNumber(position) {
            const positionType = this.positionTypes.find(
                (p) => p.positionDescription == position.positionDescription,
            );

            if (!positionType) return;

            return ["BUS_DRIVER", "BusRebbe", "BusTeacher"].includes(
                positionType.positionCode,
            );
        },
        pickFile(isNew = false) {
            if (isNew) {
                this.$refs.newTeacherFiles.click();
            } else {
                this.$refs.files.click();
            }
        },
        async onFilePicked(e, isNew = false) {
            this.uploading = true;

            const files = e.target.files;

            if (!files) return;

            try {
                var formData = new FormData();

                formData.append("upload_file", files[0]);

                const response = await this.$http.post(
                    "api/adminPortal/UploadFile?convertMp3=true",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    },
                );

                if (isNew) {
                    this.newTeacher.teacherNameRecording = response.url;
                } else {
                    this.rowClicked.teacherNameRecording = response.url;
                }

                this.uploading = false;
            } catch (e) {
                this.uploading = false;
            }
        },
        saveAlertTime(value) {
            this.$refs.alertTime.save(value);
        },
        playText(text) {
            let params = {
                OutputFormat: "mp3",
                Text: text,
                TextType: "text",
                VoiceId: "Matthew",
            };

            this.awsPolly.synthesizeSpeech(params, (err, data) => {
                const uInt8Array = new Uint8Array(data.AudioStream);
                const arrayBuffer = uInt8Array.buffer;
                const blob = new Blob([arrayBuffer]);
                const url = URL.createObjectURL(blob);
                console.log(url);
                var audio = new Audio(url);
                audio.play();
            });
        },
        validate() {
            const validations = [];

            if (this.$refs.pinNumber) {
                validations.push(this.$refs.pinNumber.validate(true));
            }

            validations.push(this.$refs.alertPhone.validate(true));

            // if (this.onRowClicked.positions.length) {
            //     this.onRowClicked.positions.forEach((p, index) => {
            //         validations.push(this.$refs.positionType[index].validate(true));
            //         validations.push(this.$refs.branch[index].validate(true));
            //         if (this.$refs.busNum) {
            //             validations.push(this.$refs.busNum[index].validate(true));
            //         }
            //     });
            // }

            if (this.$refs.positionType) {
                this.$refs.positionType.forEach((b, index) => {
                    validations.push(
                        this.$refs.positionType[index].validate(true),
                    );
                });
            }

            if (this.$refs.branch) {
                this.$refs.branch.forEach((b, index) => {
                    validations.push(this.$refs.branch[index].validate(true));
                });
            }

            if (this.$refs.busNum) {
                this.$refs.busNum.forEach((b, index) => {
                    validations.push(this.$refs.busNum[index].validate(true));
                });
            }

            return validations.every(Boolean);
        },
        async save() {
            if (!this.validate()) return;

            try {
                this.processing = true;

                const data = JSON.parse(JSON.stringify(this.rowClicked));

                data.pinNumber = data.pinNumber
                    ? data.pinNumber.trim()
                    : data.pinNumber;
                data.alertPhone = data.alertPhone
                    ? data.alertPhone.replaceAll("-", "")
                    : data.alertPhone;
                data.alertPhone = data.alertPhone
                    ? data.alertPhone.length == 11
                        ? data.alertPhone
                        : "1" + data.alertPhone
                    : "";

                data.alertTime = data.alertTime
                    ? moment(data.alertTime, "h:mm").format("hh:mm A")
                    : null;

                data.positions = data.positions.map((position) => {
                    const positionType = this.positionTypes.find(
                        (p) =>
                            p.positionDescription ==
                            position.positionDescription,
                    );

                    position.positionTypeID = positionType.positionTypeID;
                    position.updatedBy = this.$store.state.authentication.user;

                    return position;
                });

                await this.$http.post("api/kesherEmployees/save", data);

                this.updateTeacherDialog = false;
                this.processing = false;

                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async deleteTeacher() {
            this.deletingTeacher = true;

            try {
                await this.$http.post(
                    "api/teachers/deleteTeacher?teacherCode=" +
                        this.rowClicked.teacherCode,
                );

                this.deleteTeacherConfirmationDialog = false;
                this.updateTeacherDialog = false;
                this.deletingTeacher = false;

                this.$refs.grid.reloadGrid();
            } catch (e) {
            } finally {
                this.deletingTeacher = false;
            }
        },
    },
};
</script>
<style>
.gray-fg {
    color: #999;
}
.employee-search.container {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    padding-right: 0px !important;
    padding-left: 0px !important;
}
.employee-list.v-card {
    box-shadow: 0 0 0 0 !important;
}
.employee-list.green-card {
    box-shadow: 0 0 0 0 !important;
}
</style>
